import MembershipEditorContainer from './containers/MembershipEditorContainer'

export default MembershipEditorContainer
